import { render, staticRenderFns } from "./RatingSelect.vue?vue&type=template&id=95added0&scoped=true&"
import script from "./RatingSelect.vue?vue&type=script&lang=js&"
export * from "./RatingSelect.vue?vue&type=script&lang=js&"
import style0 from "./RatingSelect.vue?vue&type=style&index=0&id=95added0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95added0",
  null
  
)

export default component.exports